import axios from "axios";
import { BASE_URL } from "../../Config/BaseUrl";

const token = localStorage.getItem("token");

const createAxiosConfig = (url, method, data) => {
  return {
    method,
    url: `${BASE_URL}${url}/`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data,
  };
};

export const AttendenceReportAPI = {
    inOutTimeReportArr: async (data) => {
    const axiosConfig = createAxiosConfig(
      "in_out_time_report_arr",
      "POST",
      data
    );
    return await axios(axiosConfig)
  },
}